import { render, staticRenderFns } from "./NewFeature.vue?vue&type=template&id=2f7779de&scoped=true"
import script from "./NewFeature.vue?vue&type=script&lang=js"
export * from "./NewFeature.vue?vue&type=script&lang=js"
import style0 from "./NewFeature.vue?vue&type=style&index=0&id=2f7779de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7779de",
  null
  
)

export default component.exports